import UsageIcon from '../UsageIcon/UsageIcon';
import styles from './prepaidCard.module.scss';
import React from 'react';

export const VirtualCardRestrictionDiagram = () => {
  return (
    <div className={styles.virtualCardRestriction}>
      <UsageIcon location="online" usage={true} label="Online" />
      <UsageIcon location="phone" usage={true} label="Phone" />
      <UsageIcon location="in-store" usage={false} label="In-store" />
    </div>
  );
};
